import Text from 'components/Text';
import { fontSizes } from 'appconstants';
import { cn } from 'lib/utils';

interface DetailRowProps {
  label: string;
  value: string;
  valueClass?: string;
  isBadge?: boolean;
}

const DetailRow = ({ label, value, valueClass, isBadge }: DetailRowProps) => {
  return (
    <div className='flex justify-between py-2.5 border-b gap-4 last:border-b-0'>
      <Text text={label} size={fontSizes.h14} />
      {isBadge ? (
        <span className={valueClass}>{value}</span>
      ) : (
        <Text text={value} className={cn('text-muted-foreground text-right', valueClass)} size={fontSizes.h14} />
      )}
    </div>
  );
};

export default DetailRow;